import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageLimitDataShareService {
  private pageLimit!: BehaviorSubject<{ [key: string]: number }>;
  constructor(@Inject(PLATFORM_ID) private platformID: Object) {
    let initialData: { [key: string]: number } = {};
    if (isPlatformBrowser(this.platformID)) {
      initialData = JSON.parse(sessionStorage.getItem('pageRowLimit')!) || {};
    }
    this.pageLimit = new BehaviorSubject<{ [key: string]: number }>(initialData);
  }

  setPageLimit = (componentName: string, data: number) => {
    const pageRowData = this.pageLimit.value;
    pageRowData[componentName] = data;
    this.pageLimit.next(pageRowData);
    if (isPlatformBrowser(this.platformID)) {
      sessionStorage.setItem('pageRowLimit', JSON.stringify(pageRowData));
    }
  };

  getPageLimit = (componentName: string): Observable<number> => {
    return this.pageLimit.asObservable().pipe(
      map((data) => {
        if (data[componentName]) {
          return data[componentName];
        }
        return 10;
      }),
    );
  };
}
